import { type ClassValue, clsx } from "clsx";
import {
  type ConfigExtension,
  type DefaultClassGroupIds,
  type DefaultThemeGroupIds,
  extendTailwindMerge,
} from "tailwind-merge";

// globals.css defines text-heading-*, text-copy-*, text-label-* and text-button-*
// as font sizes. Unregistered, tailwind-merge files them as text colors and drops
// either the size or the color beside it.
export const tailwindMergeConfig: ConfigExtension<
  DefaultClassGroupIds,
  DefaultThemeGroupIds
> = {
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            (value: string) =>
              /^(heading|copy|label|button)-\d+(-mono)?$/.test(value),
          ],
        },
      ],
    },
  },
};

const twMerge = extendTailwindMerge(tailwindMergeConfig);

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
